import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAlarmClock } from '@fortawesome/pro-regular-svg-icons/faAlarmClock';
import { faChartLine } from '@fortawesome/pro-regular-svg-icons/faChartLine';

import { TooltipPro } from 'epn-ui';
import useI18n, { LocaleTypes } from '@i18n';

import getPluralForm from '@utils/formatters/getPluralForm';
import { IGetMotivationData } from '@api/types';
import apiHooks from '@apiHooks';
import LevelTooltip from '@base/BaseMotivation/LevelTooltip';

const { useMotivations } = apiHooks;

interface IRemaindCounter {
    endDate: number;
    handleModal?: () => void;
}

const daysLocaleMap = {
    [LocaleTypes.en]: ['day', 'days', 'days'],
    [LocaleTypes.ru]: ['день', 'дня', 'дней'],
};

const RemaindCounter: React.FC<IRemaindCounter> = ({ endDate, handleModal }) => {
    const { data } = useMotivations<IGetMotivationData>();
    const { t, locale } = useI18n('Statistic');

    return (
        <div className="flex flex-col lg:flex-row gap-[8px]">
            <TooltipPro title={<LevelTooltip handleModal={handleModal} />} placement="topRight">
                <div className="flex items-center ml-5 xs:px-3 text-p2 xs:py-1 xs:rounded-3 whitespace-nowrap xs:bg-blueGray-100 text-blueGray-500 hover:text-blueGray-300">
                    <FontAwesomeIcon className="mr-2" icon={faChartLine} />
                    <span>{t('Your level:', { level: data.currentLevel })}</span>
                </div>
            </TooltipPro>
            <div className="ml-5 xs:px-3 xs:py-1 xs:rounded-3 whitespace-nowrap xs:bg-blueGray-100">
                <span className="font-medium text-blueGray-500 text-p2 xs:text-p1">
                    <FontAwesomeIcon className="mr-2 text-blueGray-300" icon={faAlarmClock} />
                    {endDate} {getPluralForm(endDate, daysLocaleMap[locale])}{' '}
                    <span className="hidden lg:inline">{t('Left')}</span>
                </span>
            </div>
        </div>
    );
};

export default RemaindCounter;
